var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"hover-item",on:{"click":_vm.itemClick}},[_c('span',{staticClass:"navbar-item"},[_c('span',{staticClass:"icon is-small"},[_c('i',{class:_vm.icon})]),_c('span',{staticClass:"pl-1"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }